export const testIds = {
    InventoryListingScreenAddCarModalButton: 'InventoryListingScreenAddCarModalButton',
    InventoryListingScreenAddCarButton: 'InventoryListingScreenAddCarButton',
    InventoryListingScreenAddCarModalLeadIdInput: 'InventoryListingScreenAddCarModalLeadIdInput',
    listSearchInput: 'listSearchInput'
};